// src/components/form/MUITextFieldAdapter.tsx
import React, { forwardRef } from "react";
import { TextField, TextFieldProps } from "@mui/material";

/**
 * Props expected by `react-phone-number-input/input`.
 *  - value?: string
 *  - onChange?: (value?: string) => void
 */
interface PhoneInputAdapterProps
  extends Omit<TextFieldProps, "value" | "onChange"> {
  value?: string;
  onChange?: (value?: string) => void;
}

/**
 * Bridges MUI's onChange(event) → onChange(value)
 * so the phone-parser always receives a plain string.
 */
const MUITextFieldAdapter = forwardRef<
  HTMLInputElement,
  PhoneInputAdapterProps
>(({ value, onChange, ...rest }, ref) => (
  <TextField
    {...rest}
    inputRef={ref}
    value={value ?? ""}
    onChange={(e) => onChange?.(e.target.value)}
  />
));

export default MUITextFieldAdapter;
